<template>
  <maot-section :title="title">
    <template #title><slot name="title"/></template>
    <template #right v-if="!readonly">
      <slot name="buttons"
            :addRow="addRow"
            :deleteRow="deleteRow"
            :allCheckValue="allCheckValue"
            :onClickAllCheck="onClickAllCheck"
      >
        <vs-button color="secondary" @click="addRow"> 항목추가 </vs-button>
        <vs-button color="secondary" type="border" class="ml-2" @click="deleteRow"> 선택삭제 </vs-button>
      </slot>
    </template>
    <div class="col-span-12">
      <slot name="header" />
      <slot v-for="(row, rowIndex) in rows"
            :index="rowIndex"
            :checked="row.check"
            :onCheck="onCheck"
            :data="row"
      >
        {{ row }}
      </slot>
      <slot name="footer" />
    </div>
  </maot-section>
</template>

<script>
import MaotSection from "@/components/layout/MaotSection.vue";

export default {
  name: "AddRowLayout",
  components: {MaotSection},
  props: {
    title: String,
    value: Array,
    readonly: Boolean,
    dataForm: [Object, String, Number, Boolean, Array],
  },
  computed: {
    rows: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    },

    allCheckValue() {
      return this.rows.every(row => row.check);
    }
  },
  data() {
    return {
      id: Math.random().toString(36).substr(2, 9),
    }
  },
  methods: {
    addRow () {
      this.rows.push(Object.assign({check: false}, this.dataForm));
    },
    deleteRow (index) {
      if (index === -1) {
        this.rows.pop();
      } else {
        this.rows.filter(row => row.check).forEach(row => this.rows.splice(this.rows.indexOf(row), 1));
      }
      this.$set(this, 'rows', this.rows);
    },
    onClickAllCheck () {
      this.rows.forEach(row => row.check = !this.allCheckValue);
    },
    onCheck (index) {
      this.rows[index].check = !this.rows[index].check;
    }
  }
}
</script>

<style scoped lang="scss">
</style>
